import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const Recommendations = lazy(() =>
  import('@features/recommendations-center/components/RecommendationCenterContainer').then(
    (module) => ({ default: module.RecommendationCenterContainer })
  )
);

export const Route = createFileRoute('/_auth/recommendations')({
  component: RecommendationComponent,
});

function RecommendationComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <Recommendations />
    </Suspense>
  );
}
